export default "__VITE_ASSET__gEQzicIN__"